import { MessageBox } from '@common/components/MessageBox';
import * as React from 'react';
import { FieldPickerProps, useFieldPickerController } from './field-picker.controller';
import { Search } from '@common/components/Search';
import { Label } from '@common/components/Label';
import { trDts } from '@modules/datasheets/utils/i18n';
import Tree from '@common/components/Tree';
import { Fields } from './components/fields';
import cx from 'classnames';
import { Flex } from '@common/components/Flex';
import { getTestAttributes } from '@common/utils/tests';

import './field-picker.styles.scss';

export const FieldPicker: React.FC<FieldPickerProps> = (props) => {
  const { className, selection, dndType, isFieldAdded, disabled } = props;
  const {
    fieldsLoading,
    folders,
    selectedFolder,
    fieldsProcessed,
    handleSearch,
    handleFolderChange,
    closeMessage,
    messageProps,
    expanded,
    toggleExpanded,
  } = useFieldPickerController(props);

  const hiddenElementStyleIfNeeded = React.useMemo(() => (expanded ? undefined : { display: 'none' }), [expanded]);

  return (
    <div 
      className={cx(
        "DatasheetsEditor__field-picker", 
        { 
          'DatasheetsEditor__field-picker--expanded': expanded,
          'DatasheetsEditor__field-picker--disabled': disabled,
        }, 
        className
      )}
    >
      <MessageBox
        hideMessageBox={closeMessage}
        {...messageProps}
      />
      <Flex alignItems="center">
        <Search 
          withLiveSearch
          id="data-sheet-tab-wnd-lp-suggest-box"
          className="DatasheetsEditor__field-picker__search-form"
          classes={{ searchForm: 'DatasheetsEditor__field-picker__search-form-input' }} 
          onSearch={handleSearch} 
          style={hiddenElementStyleIfNeeded} 
        />
        <button {...getTestAttributes({ id: 'fp-datasheet-design-left-toggle-button' })} className="DatasheetsEditor__field-picker__toggler" onClick={toggleExpanded}>
          <img src={expanded ? "png/arrow_left.png" : "png/arrow_right.png"} />
        </button>
      </Flex>
      <Label text={trDts('Folders')} style={hiddenElementStyleIfNeeded} className="DatasheetsEditor__field-picker__label" />
      <Tree 
        style={hiddenElementStyleIfNeeded}  
        className="DatasheetsEditor__field-picker__list"
        items={folders}
        value={selectedFolder?.id}
        onChange={handleFolderChange}
      />
      <Label text={trDts('Fields')} className="DatasheetsEditor__field-picker__label" style={hiddenElementStyleIfNeeded} />
      <Fields 
        isFieldAdded={isFieldAdded}
        style={hiddenElementStyleIfNeeded}
        className="DatasheetsEditor__field-picker__list"
        fields={fieldsProcessed}
        loading={fieldsLoading}
        selection={selection}
        dndType={dndType}
      />
    </div>
  );
};